import {
  criarConversa,
  enviarMensagem,
  enviarMensagemMidia,
  excluirConversa,
  excluirMensagem,
  listarConversas,
  listarMensagens,
  listarPipelines,
} from './playground-ia-api'
import {
  executionContextLabel,
  formatExecutionTime,
  formatJson,
  formatToolName,
  aguardar,
  formatarDataHoraAgora,
  intervaloRevelacaoMensagem,
  scrollChatToBottom,
} from './playground-ia-helpers'

export default {
  name: 'PlaygroundIA',
  props: {
    treinamentoId: {
      type: [String, Number],
      default: '',
    },
    treinamentoNome: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visivel: false,
      carregandoInicial: false,
      criandoConversa: false,
      excluindoConversaId: null,
      selecionandoConversaId: null,
      carregandoMensagens: false,
      enviando: false,
      revelandoResposta: false,
      mensagemOtimistaId: null,
      conversas: [],
      conversaAtivaId: null,
      mensagens: [],
      pipelines: [],
      pipelinePadraoId: null,
      pipelinePadraoNome: null,
      novaConversaNome: '',
      novaConversaPipelineId: '',
      mostrarFormNovaConversa: false,
      textoMensagem: '',
      processandoMidia: false,
      gravandoAudio: false,
      processandoGravacaoAudio: false,
      gravacaoIniciadaEm: null,
      duracaoGravacaoSegundos: 0,
      intervaloDuracaoGravacao: null,
      audioProntoParaEnviar: false,
      gravadorAudio: null,
      toolsExpandidas: {},
      confirmacao: {
        visivel: false,
        titulo: '',
        mensagem: '',
        tipo: null,
        payload: null,
        processando: false,
      },
    }
  },
  computed: {
    conversaAtiva() {
      return this.conversas.find(c => this.conversaEstaAtiva(c.id)) || null
    },
    temConversaAtiva() {
      return this.conversaAtivaId !== null && this.conversaAtivaId !== ''
    },
    treinamentoIdValido() {
      const id = this.treinamentoId
      return id && id !== '__novo__'
    },
    pipelineSelecionadaLabel() {
      if (this.novaConversaPipelineId) {
        const pipeline = this.pipelines.find(
          item => String(item.id) === String(this.novaConversaPipelineId)
        )

        if (pipeline) {
          return pipeline.nome
        }
      }

      return this.pipelinePadraoNome || 'Automática'
    },
    composerDesabilitado() {
      return this.enviando
        || this.revelandoResposta
        || this.carregandoMensagens
        || this.processandoMidia
        || this.gravandoAudio
    },
    temTextoMensagem() {
      return !!(this.textoMensagem || '').trim()
    },
    podeEnviarAudioGravado() {
      return this.duracaoGravacaoSegundos >= 1
    },
    acaoComposerCarregando() {
      return this.enviando || this.revelandoResposta
    },
  },
  methods: {
    formatToolName,
    formatExecutionTime,
    formatJson,
    executionContextLabel,
    normalizarConversaId(conversaId) {
      if (conversaId === null || conversaId === undefined || conversaId === '') {
        return null
      }

      return String(conversaId)
    },
    conversaEstaAtiva(conversaId) {
      const id = this.normalizarConversaId(conversaId)
      return id !== null && id === this.conversaAtivaId
    },
    aplicarPipelinePadrao() {
      if (this.pipelinePadraoId) {
        this.novaConversaPipelineId = String(this.pipelinePadraoId)
      } else if (this.pipelines.length === 1) {
        this.novaConversaPipelineId = String(this.pipelines[0].id)
      } else {
        this.novaConversaPipelineId = ''
      }
    },
    resetarEstadoModal() {
      this.conversaAtivaId = null
      this.mensagens = []
      this.conversas = []
      this.textoMensagem = ''
      this.toolsExpandidas = {}
      this.mostrarFormNovaConversa = false
      this.novaConversaNome = ''
      this.criandoConversa = false
      this.excluindoConversaId = null
      this.selecionandoConversaId = null
      this.revelandoResposta = false
      this.mensagemOtimistaId = null
      this.encerrarConfirmacao()
    },
    bloquearScrollPagina() {
      document.body.classList.add('ia-playground-modal-open')
    },
    liberarScrollPagina() {
      document.body.classList.remove('ia-playground-modal-open')
    },
    ocultarOverlayerPagina() {
      document.getElementById('overlayer-loading')?.classList.remove('show-overlayer')
    },
    async abrir() {
      if (!this.treinamentoIdValido) {
        return
      }

      this.ocultarOverlayerPagina()
      this.resetarEstadoModal()
      this.visivel = true
      this.bloquearScrollPagina()

      await this.inicializar()
    },
    fechar() {
      this.cancelarGravacaoAudio()
      this.visivel = false
      this.liberarScrollPagina()
      this.encerrarConfirmacao()
    },
    async inicializar() {
      this.carregandoInicial = true

      try {
        const [pipelinesRes, conversasRes] = await Promise.all([
          listarPipelines(this.treinamentoId),
          listarConversas(this.treinamentoId),
        ])

        this.pipelines = pipelinesRes.data?.pipelines || []
        this.pipelinePadraoId = pipelinesRes.data?.pipeline_padrao_id || null
        this.pipelinePadraoNome = pipelinesRes.data?.pipeline_padrao_nome || null
        this.conversas = conversasRes.data?.conversas || []
        this.aplicarPipelinePadrao()

        if (this.conversas.length > 0) {
          await this.selecionarConversa(this.conversas[0].id)
        }
      } catch (e) {
        window.showToastDanger?.('body', 'Erro ao carregar o Playground.')
      } finally {
        this.carregandoInicial = false
      }
    },
    async recarregarConversas(manterAtiva = true) {
      const conversaAtivaAnterior = this.conversaAtivaId

      try {
        const res = await listarConversas(this.treinamentoId)
        this.conversas = res.data?.conversas || []
      } catch (e) {
        return
      }

      if (!manterAtiva) {
        return
      }

      if (!this.conversas.length) {
        this.conversaAtivaId = null
        this.mensagens = []
        return
      }

      const aindaExiste = this.conversas.some(
        conversa => this.conversaEstaAtiva(conversa.id)
      )

      if (!aindaExiste) {
        await this.selecionarConversa(this.conversas[0].id)
        return
      }

      if (conversaAtivaAnterior) {
        this.conversaAtivaId = conversaAtivaAnterior
      }
    },
    async selecionarConversa(conversaId) {
      const id = this.normalizarConversaId(conversaId)

      if (!id) {
        return
      }

      this.conversaAtivaId = id
      this.selecionandoConversaId = id
      this.carregandoMensagens = true
      this.toolsExpandidas = {}

      try {
        const res = await listarMensagens(id)
        this.mensagens = res.data?.mensagens || []
        this.$nextTick(() => {
          scrollChatToBottom(this.$refs.chatTimeline)
        })
      } catch (e) {
        this.mensagens = []
        const msg = e?.response?.data?.error || 'Erro ao carregar mensagens.'
        window.showToastDanger?.('body', msg)
        await this.recarregarConversas(false)

        if (!this.conversas.some(conversa => this.conversaEstaAtiva(conversa.id))) {
          this.conversaAtivaId = null
        }
      } finally {
        this.carregandoMensagens = false
        this.selecionandoConversaId = null
      }
    },
    toggleFormNovaConversa() {
      this.mostrarFormNovaConversa = !this.mostrarFormNovaConversa

      if (this.mostrarFormNovaConversa) {
        this.aplicarPipelinePadrao()
      }
    },
    async criarNovaConversa() {
      const nome = (this.novaConversaNome || '').trim()

      if (!nome) {
        window.showToastDanger?.('body', 'Informe um nome para a conversa.')
        return
      }

      if (this.criandoConversa) {
        return
      }

      const payload = { nome }
      if (this.novaConversaPipelineId) {
        payload.pipeline_id = Number(this.novaConversaPipelineId)
      }

      this.criandoConversa = true

      try {
        const res = await criarConversa(this.treinamentoId, payload)
        const conversa = res.data?.conversa

        if (!conversa || !conversa.id) {
          throw new Error('Resposta inválida ao criar conversa.')
        }

        const conversaId = this.normalizarConversaId(conversa.id)

        if (!conversaId) {
          throw new Error('Resposta inválida ao criar conversa.')
        }

        const conversaJaListada = this.conversas.some(
          item => String(item.id) === conversaId
        )

        if (!conversaJaListada) {
          this.conversas.unshift(conversa)
        }

        this.novaConversaNome = ''
        this.mostrarFormNovaConversa = false
        this.conversaAtivaId = conversaId
        this.mensagens = []
        await this.selecionarConversa(conversaId)
        await this.recarregarConversas(false)

        if (!this.conversaEstaAtiva(conversaId)) {
          this.conversaAtivaId = conversaId
        }

        window.showToastSuccess?.('body', 'Conversa criada com sucesso.')
      } catch (e) {
        const msg = e?.response?.data?.error || e?.response?.data?.message || e.message || 'Erro ao criar conversa.'
        window.showToastDanger?.('body', msg)
      } finally {
        this.criandoConversa = false
      }
    },
    solicitarExcluirConversa(conversa) {
      this.abrirConfirmacao({
        tipo: 'conversa',
        titulo: 'Excluir conversa',
        mensagem: `Excluir a conversa "${conversa.nome}" e todo o histórico? Esta ação não pode ser desfeita.`,
        payload: conversa,
      })
    },
    solicitarExcluirMensagem(mensagem) {
      this.abrirConfirmacao({
        tipo: 'mensagem',
        titulo: 'Excluir mensagem',
        mensagem: 'Excluir esta mensagem? Esta ação não pode ser desfeita.',
        payload: mensagem,
      })
    },
    abrirConfirmacao({ tipo, titulo, mensagem, payload }) {
      this.confirmacao = {
        visivel: true,
        titulo,
        mensagem,
        tipo,
        payload,
        processando: false,
      }
    },
    encerrarConfirmacao() {
      this.confirmacao = {
        visivel: false,
        titulo: '',
        mensagem: '',
        tipo: null,
        payload: null,
        processando: false,
      }
    },
    fecharConfirmacao() {
      if (this.confirmacao.processando) {
        return
      }

      this.encerrarConfirmacao()
    },
    async executarConfirmacao() {
      if (this.confirmacao.processando) {
        return
      }

      if (this.confirmacao.tipo === 'conversa') {
        await this.excluirConversaConfirmada(this.confirmacao.payload)
        return
      }

      if (this.confirmacao.tipo === 'mensagem') {
        await this.excluirMensagemConfirmada(this.confirmacao.payload)
      }
    },
    async excluirConversaConfirmada(conversa) {
      const conversaId = this.normalizarConversaId(conversa?.id)

      if (!conversaId) {
        return
      }

      this.confirmacao.processando = true
      this.excluindoConversaId = conversaId

      try {
        await excluirConversa(conversaId)

        const eraAtiva = this.conversaEstaAtiva(conversaId)

        this.conversas = this.conversas.filter(
          item => String(item.id) !== conversaId
        )

        if (eraAtiva) {
          this.conversaAtivaId = null
          this.mensagens = []
        }

        await this.recarregarConversas(false)
        this.encerrarConfirmacao()
        window.showToastSuccess?.('body', 'Conversa excluída com sucesso.')

        if (eraAtiva && this.conversas.length > 0) {
          await this.selecionarConversa(this.conversas[0].id)
        }
      } catch (e) {
        const msg = e?.response?.data?.error || 'Erro ao excluir conversa.'
        window.showToastDanger?.('body', msg)
        await this.recarregarConversas(false)

        if (!this.conversas.some(item => String(item.id) === conversaId)) {
          if (this.conversaEstaAtiva(conversaId)) {
            this.conversaAtivaId = null
            this.mensagens = []
          }
          this.encerrarConfirmacao()
        }
      } finally {
        this.confirmacao.processando = false
        this.excluindoConversaId = null
      }
    },
    async excluirMensagemConfirmada(mensagem) {
      if (!mensagem?.id || !this.conversaAtivaId) {
        return
      }

      const mensagemId = String(mensagem.id)

      this.confirmacao.processando = true

      try {
        await excluirMensagem(mensagem.id)
        this.mensagens = this.mensagens.filter(
          item => String(item.id) !== mensagemId
        )
        window.showToastSuccess?.('body', 'Mensagem excluída com sucesso.')
        this.encerrarConfirmacao()
      } catch (e) {
        this.confirmacao.processando = false
        const msg = e?.response?.data?.error || 'Erro ao excluir mensagem.'
        window.showToastDanger?.('body', msg)
      }
    },
    async enviarMensagemUsuario() {
      const texto = (this.textoMensagem || '').trim()

      if (!texto || !this.conversaAtivaId || this.composerDesabilitado) {
        return
      }

      this.textoMensagem = ''
      await this.enviarConteudoUsuario(texto)
    },
    async enviarConteudoUsuario(texto, opcoes = {}) {
      if (!texto || !this.conversaAtivaId || this.enviando || this.revelandoResposta) {
        this.processandoMidia = false
        return
      }

      const mensagemOtimistaId = `otimista-${Date.now()}`
      this.mensagemOtimistaId = mensagemOtimistaId
      this.mensagens.push({
        id: mensagemOtimistaId,
        papel: 'user',
        conteudo: texto,
        created_at: formatarDataHoraAgora(),
        pendente: true,
      })

      this.enviando = true
      this.$nextTick(() => {
        scrollChatToBottom(this.$refs.chatTimeline)
      })

      try {
        const res = opcoes.enviarMidia
          ? await enviarMensagemMidia(this.conversaAtivaId, opcoes.arquivo)
          : await enviarMensagem(this.conversaAtivaId, texto)
        const novas = res.data?.mensagens || []

        this.enviando = false

        if (novas.length) {
          await this.revelarMensagensResposta(novas, mensagemOtimistaId)
        } else {
          this.removerMensagemOtimista(mensagemOtimistaId)
          await this.selecionarConversa(this.conversaAtivaId)
        }

        await this.recarregarConversas()
      } catch (e) {
        this.removerMensagemOtimista(mensagemOtimistaId)

        if (!opcoes.enviarMidia) {
          this.textoMensagem = texto
        }

        const msg = e?.response?.data?.error
          || e?.response?.data?.message
          || Object.values(e?.response?.data?.errors || {})?.[0]?.[0]
          || 'Erro ao enviar mensagem.'
        window.showToastDanger?.('body', msg)
      } finally {
        this.enviando = false
        this.revelandoResposta = false
        this.mensagemOtimistaId = null
        this.processandoMidia = false
        this.$nextTick(() => {
          this.aplicarFontAwesomeComposer()
          this.focarInputMensagem()
        })
      }
    },
    abrirSeletorAnexo() {
      if (this.composerDesabilitado || !this.conversaAtivaId) {
        return
      }

      this.$refs.inputAnexo?.click()
    },
    async onAnexoSelecionado(event) {
      const arquivo = event?.target?.files?.[0]

      if (!arquivo || !this.conversaAtivaId || this.composerDesabilitado) {
        return
      }

      event.target.value = ''

      const rotuloOtimista = `[Anexo: ${arquivo.name}] Processando...`
      await this.enviarConteudoUsuario(rotuloOtimista, {
        enviarMidia: true,
        arquivo,
      })
    },
    async iniciarGravacaoAudio() {
      if (this.composerDesabilitado || !this.conversaAtivaId) {
        return
      }

      if (!navigator.mediaDevices?.getUserMedia) {
        window.showToastDanger?.('body', 'Seu navegador não suporta gravação de áudio.')
        return
      }

      try {
        const MicRecorder = require('mic-recorder-to-mp3')
        const gravador = new MicRecorder({ bitRate: 128 })

        await gravador.start()
        this.gravadorAudio = gravador
        this.gravandoAudio = true
        this.audioProntoParaEnviar = false
        this.gravacaoIniciadaEm = Date.now()
        this.duracaoGravacaoSegundos = 0
        this.iniciarContadorGravacaoAudio()
      } catch (e) {
        window.showToastDanger?.('body', 'Não foi possível acessar o microfone.')
      }
    },
    async pararGravacaoAudio() {
      if (!this.gravadorAudio || this.processandoGravacaoAudio) {
        return
      }

      if (!this.podeEnviarAudioGravado) {
        window.showToastDanger?.('body', 'Grave por pelo menos 1 segundo antes de enviar.')
        return
      }

      this.processandoGravacaoAudio = true
      const gravador = this.gravadorAudio
      this.gravadorAudio = null
      this.encerrarContadorGravacaoAudio()

      try {
        gravador.stop()
        const [buffer, blob] = await gravador.getMp3()
        this.gravandoAudio = false

        const tamanhoBuffer = Array.isArray(buffer) ? buffer.length : 0
        const tamanhoBlob = blob?.size || 0

        if ((!tamanhoBuffer && tamanhoBlob === 0)) {
          window.showToastDanger?.('body', 'Não foi possível gravar o áudio. Tente falar mais perto do microfone.')
          return
        }

        const arquivoAudio = new File(buffer, `audio-playground-${Date.now()}.mp3`, {
          type: 'audio/mpeg',
          lastModified: Date.now(),
        })

        if (arquivoAudio.size < 1000) {
          window.showToastDanger?.('body', 'Áudio muito curto. Grave por mais tempo e tente novamente.')
          return
        }

        await this.enviarConteudoUsuario('[Áudio] Transcrevendo...', {
          enviarMidia: true,
          arquivo: arquivoAudio,
        })
      } catch (e) {
        this.gravandoAudio = false

        if (e?.message === 'No buffer to send') {
          window.showToastDanger?.('body', 'Não foi possível capturar o áudio. Grave por mais tempo.')
          return
        }

        window.showToastDanger?.('body', 'Erro ao finalizar a gravação de áudio.')
      } finally {
        this.processandoGravacaoAudio = false
        this.processandoMidia = false
        this.audioProntoParaEnviar = false
        this.gravacaoIniciadaEm = null
        this.duracaoGravacaoSegundos = 0
        this.$nextTick(() => this.aplicarFontAwesomeComposer())
      }
    },
    cancelarGravacaoAudio() {
      if (this.processandoGravacaoAudio) {
        return
      }

      if (this.gravadorAudio) {
        this.gravadorAudio.stop()
        this.gravadorAudio = null
      }

      this.encerrarContadorGravacaoAudio()
      this.gravandoAudio = false
      this.audioProntoParaEnviar = false
      this.processandoGravacaoAudio = false
      this.gravacaoIniciadaEm = null
      this.duracaoGravacaoSegundos = 0
    },
    iniciarContadorGravacaoAudio() {
      this.encerrarContadorGravacaoAudio()
      this.intervaloDuracaoGravacao = window.setInterval(() => {
        if (!this.gravacaoIniciadaEm) {
          return
        }

        this.duracaoGravacaoSegundos = Math.floor(
          (Date.now() - this.gravacaoIniciadaEm) / 1000
        )
      }, 200)
    },
    encerrarContadorGravacaoAudio() {
      if (this.intervaloDuracaoGravacao) {
        window.clearInterval(this.intervaloDuracaoGravacao)
        this.intervaloDuracaoGravacao = null
      }
    },
    removerMensagemOtimista(mensagemOtimistaId) {
      if (!mensagemOtimistaId) {
        return
      }

      this.mensagens = this.mensagens.filter(
        mensagem => String(mensagem.id) !== String(mensagemOtimistaId)
      )
    },
    adicionarMensagemComAnimacao(mensagem) {
      this.mensagens.push({
        ...mensagem,
        entradaRecente: true,
      })

      this.$nextTick(() => {
        scrollChatToBottom(this.$refs.chatTimeline)
      })

      window.setTimeout(() => {
        const indice = this.mensagens.findIndex(
          item => String(item.id) === String(mensagem.id)
        )

        if (indice === -1) {
          return
        }

        this.$set(this.mensagens[indice], 'entradaRecente', false)
      }, 360)
    },
    async revelarMensagensResposta(novasMensagens, mensagemOtimistaId) {
      if (!novasMensagens.length) {
        this.removerMensagemOtimista(mensagemOtimistaId)
        return
      }

      this.revelandoResposta = true

      const mensagemUsuarioReal = novasMensagens.find(mensagem => mensagem.papel === 'user')
      const mensagensResposta = novasMensagens.filter(
        mensagem => !mensagemUsuarioReal || String(mensagem.id) !== String(mensagemUsuarioReal.id)
      )

      const indiceOtimista = this.mensagens.findIndex(
        mensagem => String(mensagem.id) === String(mensagemOtimistaId)
      )

      if (mensagemUsuarioReal && indiceOtimista !== -1) {
        this.$set(this.mensagens, indiceOtimista, { ...mensagemUsuarioReal })
        this.$nextTick(() => {
          scrollChatToBottom(this.$refs.chatTimeline)
        })
      } else {
        this.removerMensagemOtimista(mensagemOtimistaId)

        if (mensagemUsuarioReal) {
          this.mensagens.push(mensagemUsuarioReal)
        }
      }

      for (const mensagem of mensagensResposta) {
        await aguardar(intervaloRevelacaoMensagem(mensagem))
        this.adicionarMensagemComAnimacao(mensagem)
      }

      this.revelandoResposta = false
    },
    onEnterEnviar(event) {
      if (event.shiftKey) {
        return
      }

      event.preventDefault()
      this.enviarMensagemUsuario()
    },
    onAcaoComposer() {
      if (this.temTextoMensagem) {
        this.enviarMensagemUsuario()
        return
      }

      this.iniciarGravacaoAudio()
    },
    toggleToolExpandida(mensagemId) {
      this.$set(this.toolsExpandidas, mensagemId, !this.toolsExpandidas[mensagemId])
    },
    toolEstaExpandida(mensagemId) {
      return !!this.toolsExpandidas[mensagemId]
    },
    podeExcluirMensagem(mensagem) {
      if (mensagem.pendente) {
        return false
      }

      return ['user', 'assistant', 'tool'].includes(mensagem.papel)
    },
    rotuloPapel(papel) {
      if (papel === 'user') {
        return 'Você'
      }

      if (papel === 'assistant') {
        return 'IA'
      }

      if (papel === 'tool') {
        return 'Tool'
      }

      return papel
    },
    aplicarFontAwesomeSvg(alvo = null) {
      const elemento = alvo || this.$el

      if (!elemento || typeof window === 'undefined' || this.gravandoAudio) {
        return
      }

      const fontAwesome = window.FontAwesome

      if (fontAwesome?.dom?.i2svg) {
        fontAwesome.dom.i2svg({ node: elemento })
      }
    },
    aplicarFontAwesomeComposer() {
      this.$nextTick(() => {
        const composer = this.$el?.querySelector('.ia-playground-chat__composer')

        if (composer) {
          this.aplicarFontAwesomeSvg(composer)
        }
      })
    },
    focarInputMensagem() {
      this.$nextTick(() => {
        const input = this.$refs.inputMensagem

        if (!input || this.composerDesabilitado || this.gravandoAudio) {
          return
        }

        input.focus()
      })
    },
  },
  watch: {
    treinamentoId(newVal, oldVal) {
      if (String(newVal) !== String(oldVal) && this.visivel) {
        this.fechar()
        this.resetarEstadoModal()
      }
    },
    textoMensagem() {
      this.aplicarFontAwesomeComposer()
    },
    acaoComposerCarregando(valorAnterior, valorAtual) {
      if (valorAnterior && !valorAtual) {
        this.aplicarFontAwesomeComposer()
      }
    },
    visivel(valor) {
      if (valor) {
        this.$nextTick(() => this.aplicarFontAwesomeSvg())
      }
    },
  },
  mounted() {
    this.$nextTick(() => this.aplicarFontAwesomeSvg())
  },
  beforeDestroy() {
    this.encerrarContadorGravacaoAudio()
    this.cancelarGravacaoAudio()
    this.liberarScrollPagina()
    this.encerrarConfirmacao()
  },
}
